import { observable, action, computed } from 'mobx'
import { axios } from '../lib';

const TOKEN_NAME = 'jwtToken';

class AuthenticationStore {
  @observable user;
  @observable isSending = false;
  @observable isChecked = false;
  @observable attempts = 0;
  @observable errorMessage;

  @action validate() {
    const token = localStorage.getItem(TOKEN_NAME);
    if (token) {
      axios.get('auth/login')
      .then((result) => {
        localStorage.setItem(TOKEN_NAME, result.data.token);
        this.user = result.data.user;
        this.isChecked = true;
      })
      .catch((error) => {
        console.log(JSON.stringify(error))
        localStorage.removeItem(TOKEN_NAME);
        this.isChecked = true;
      });
    }
    else {
      this.isChecked = true;
    }
  }

  @action authenticate(data) {
    localStorage.setItem(TOKEN_NAME, data.token);
    this.user = data.user;
  }

  @action logout() {
    localStorage.removeItem(TOKEN_NAME);
    this.user = undefined;
  }

  @computed get isAuthenticated() {
    // return this.user;
    return true;
  }
}

export default new AuthenticationStore();



// WEBPACK FOOTER //
// ./src/stores/AuthenticationStore.js